// Sticky pre-fill memory shared across all log forms (Site Location, Operator
// Name & Initials). Persisted locally so repeat logging on the same device is
// fast and consistent for court-proof audit trails.
const K = {
  location: "sb_last_location",
  name: "sb_last_name",
  initials: "sb_last_initials",
};

export function getSticky(key) {
  try {
    return localStorage.getItem(K[key]) || "";
  } catch {
    return "";
  }
}

export function setSticky(key, val) {
  try {
    if (val && String(val).trim()) localStorage.setItem(K[key], String(val).trim());
  } catch {
    /* ignore */
  }
}
